import { browser } from '$app/environment';
import { Page } from '$lib/utils/page';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';

export const prerender = true;

/**
 * Load function for aa-offer page
 * @returns {Promise<{page?: any} | undefined>} Page configuration object
 */
export async function load() {
	if (browser) {
		const page = new Page({
			routePath: '/aa-offer',
			policies: { policy, policyExceptionHandler },
			conditions: pageConditions
		});
		return {
			page
		};
	}
}
